import { render, staticRenderFns } from "./DateRangeLegend.vue?vue&type=template&id=57cdc4c0&scoped=true&"
import script from "./DateRangeLegend.vue?vue&type=script&lang=js&"
export * from "./DateRangeLegend.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeLegend.vue?vue&type=style&index=0&id=57cdc4c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cdc4c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57cdc4c0')) {
      api.createRecord('57cdc4c0', component.options)
    } else {
      api.reload('57cdc4c0', component.options)
    }
    module.hot.accept("./DateRangeLegend.vue?vue&type=template&id=57cdc4c0&scoped=true&", function () {
      api.rerender('57cdc4c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qtxRESTzOewW/JS/comp/DateRangeLegend.vue"
export default component.exports